import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import { useDebounce, useSetState } from '@campaignhub/react-hooks'

import PageContext from '@contexts/pageContext'

import useProvidersV4 from '@hooks/useProvidersV4'

import InfiniteLinkingTags from '@components/InfiniteLinkingTags'

const defaultState = {
  searchFilter: '',
}

const ProviderLinking = (props) => {
  const { callbacks, linkedProviders } = props
  const { toggleUpdateLinkedProviders } = callbacks

  const { loadingLinkedProviders } = useContext(PageContext)

  const [state, setState] = useSetState(defaultState)
  const { searchFilter } = state

  const debouncedSearchFilter = useDebounce(searchFilter, 300)

  const { filteredProvidersV4: filteredProviders, loading, hasMore, callbacks: { loadNextPage, loadInitialPage } } = useProvidersV4({ searchFilter: debouncedSearchFilter })

  useEffect(() => {
    loadInitialPage()
  }, [debouncedSearchFilter])

  const toggleProvider = (provider, type) => {
    let newList = []

    if (type === 'add'){
      newList = [...linkedProviders, provider]
    } else {
      newList = linkedProviders.filter(x => x.id !== provider.id)
    }

    toggleUpdateLinkedProviders(newList)
  }

  return (
    <InfiniteLinkingTags
      label="Providers"
      secondLabel={`(${linkedProviders.length})`}
      options={filteredProviders}
      selectedItems={linkedProviders}
      onSelect={item => toggleProvider(item, 'add')}
      onRemove={item => toggleProvider(item)}
      onLoadMore={loadNextPage}
      hasMore={hasMore}
      loading={loading}
      loadingLinkedItems={loadingLinkedProviders}
      placeholder="Search Providers"
      labelKey="name"
      valueKey="id"
      searchFilter={searchFilter}
      onSearchChange={val => setState({ searchFilter: val })}
    />
  )
}

ProviderLinking.propTypes = {
  callbacks: PropTypes.object,
  linkedProviders: PropTypes.array,
  zoneForm: PropTypes.object,
}

export default ProviderLinking
